/**
 * `EngineInvariantError` — the pure core's one sanctioned throw.
 *
 * @remarks
 * Result-typed operations (architecture.md §3.3) reserve throwing for
 * programmer error and corrupt bundles — states the loader's validation
 * gates exist to make unreachable (a dangling flag reference, an entry room
 * that is not in the index, a caller seed that contradicts a fixed seed
 * policy). Reaching one at runtime means an upstream contract was broken,
 * and the honest response is a loud, named crash — never a quiet `false`
 * that would turn a corrupt bundle into plausible-looking fiction.
 *
 * Player-facing refusal is NEVER this: refusals are `ActionRejection` data.
 *
 * @packageDocumentation
 */

/** Thrown when the engine meets a state its upstream contracts promise cannot exist. */
export class EngineInvariantError extends Error {
	public constructor(message: string) {
		super(message);
		this.name = 'EngineInvariantError';
	}
}
